import React from 'react';
import { XCircle } from 'lucide-react';
const pains = ['Llegás a la pileta sin saber exactamente qué ejercicios vas a dar hoy', 'Tus alumnos no progresan porque no hay un orden claro de contenidos semana a semana', 'Tenés grupos con niveles mezclados y no sabés cómo manejarlos al mismo tiempo', 'Cuando falta un alumno o hay feriado perdés la continuidad de lo que venías trabajando', 'No podés justificar un aumento de cuota porque no tenés nada sistematizado ni registrado', 'El domingo a la noche te genera ansiedad pensar en la semana que viene sin tener nada preparado', 'Buscás ejercicios en YouTube y YouTube te da cosas que no funcionan en tu pileta real', 'Nadie valora tu trabajo porque los resultados de tus alumnos no se ven reflejados en avances concretos y medibles'];
export function PainPoints() {
  return <section className="py-20 bg-brand-light/30" data-id="element-203">
      <div className="max-w-4xl mx-auto px-4" data-id="element-204">
        <div className="text-center mb-12" data-id="element-205">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-gray-900 mb-4" data-id="element-206">
            Si sos profe de natación, <br className="hidden md:block" data-id="element-207" />
            esto te va a sonar conocido:
          </h2>
        </div>

        <div className="bg-white rounded-2xl shadow-lg p-8 md:p-12 border border-gray-100 mb-12" data-id="element-208">
          <ul className="space-y-6" data-id="element-209">
            {pains.map((pain, i) => <li key={i} className="flex items-start gap-4" data-id="element-210">
                <XCircle className="w-6 h-6 text-red-500 flex-shrink-0 mt-0.5" data-id="element-211" />
                <span className="text-gray-700 text-lg" data-id="element-212">{pain}</span>
              </li>)}
          </ul>
        </div>

        <div className="text-center" data-id="element-213">
          <h3 className="text-2xl md:text-3xl font-heading font-bold text-gray-900 mb-8" data-id="element-214">
            "¿Cuántas clases más vas a improvisar?"
          </h3>
          <a href="#pricing" className="inline-block bg-brand-blue hover:bg-brand-dark text-white font-bold text-lg py-4 px-8 rounded-xl shadow-lg shadow-brand-blue/30 transition-all transform hover:-translate-y-1" data-id="element-215">
            👉 BASTA DE IMPROVISAR — QUIERO MI NATACIÓN 360
          </a>
        </div>
      </div>
    </section>;
}